import { createFlag } from './createFlag';

export const ENABLE_DASHIFY_DEV_TOOL = createFlag({
  remoteFlagName: 'ui.enable.dashify.dev.tool',
  description:
    'This flag enables CNAO users to access the dev tool page (dashboards/dev/tool) to manually override the feature flags for local testing purposes. It is intended to be enabled only for demo purposes.',
  defaultValue: true,
});

export const ENABLE_DASHIFY_EDITOR = createFlag({
  remoteFlagName: 'ui.enable.dashify.editor',
  description:
    'This flag enables CNAO users to access the simple dashify editor. It is intended to be enabled only for demo purposes.',
  defaultValue: false,
});

export const ENABLE_ADVANCED_DASHIFY_EDITOR = createFlag({
  remoteFlagName: 'ui.enable.adv.dashify.editor',
  description:
    'This flag enables CNAO users to access the advanced dashify editor. It is intended to be enabled only for demo purposes.',
  defaultValue: false,
});

export const SKIP_DASHBOARD_PERMISSION_CHECK = createFlag({
  remoteFlagName: 'ui.dashboard.permission.skip.check',
  description: 'This flag skips the dashboard permission checking in case IAM does not work properly with OKTA logins.',
  defaultValue: true,
});

export const ENABLE_TEMPORARY_DS_LOADING_BAR = createFlag({
  remoteFlagName: 'ui.enable.dashify.temp.loading.bar',
  description: 'This flag enables temporary data source loading bar solution',
  defaultValue: false,
});
